import { FC, lazy, memo } from 'react'

export const loadIcon = (iconName?: string) => {
  if (iconName) {
    return lazy(() => import(`react-pay-icons/lib/${iconName}`))
  }
  return () => <></>
}

const getCCproviderCode = (cardMask: string, brandName: string) => {
  const re: any = {
    VisaElectron: /^(4026|417500|4405|4508|4844|4913|4917)[x0-9]+$/,
    Maestro:
      /^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)[x0-9]+$/,
    Dankort: /^(5019)[x0-9]+$/,
    // interpayment: /^(636)[x0-9]+$/,
    UnionPay: /^(62|88)[x0-9]+$/,
    Visa: /^4[x0-9]{12}(?:[x0-9]{3})?$/,
    Mastercard: /^5[1-5][x0-9]{14}$/,
    Amex: /^3[47][x0-9]{13}$/,
    Diners: /^3(?:0[0-5]|[68][x0-9])[x0-9]{11}$/,
    Discover: /^6(?:011|5[x0-9]{2})[x0-9]{12}$/,
    Jcb: /^(?:2131|1800|35[x0-9]{3})[x0-9]{11}$/,
  }

  for (const key in re) {
    if (re[key].test(cardMask?.toLowerCase())) {
      return key
    }
    if (key.toLowerCase() === brandName?.toLowerCase()) {
      return key
    }
  }
}

const CCProviderComponent: FC<any> = ({
  cardMask,
  brandName,
  height = 16,
  display = 'inline',
  borderRadius = '3px',
}) => {
  const customStyles = { height, display, borderRadius }
  const Icon = loadIcon(getCCproviderCode(cardMask, brandName))

  return <Icon style={customStyles} />
}

export const CCProvider = memo(CCProviderComponent)
